// src/App.js
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "./context/AuthContext";
import NavBar from "./components/NavBar";
import Footer from "./components/Footer";
import ErrorBoundary from './components/ErrorBoundary';
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import Productos from "./pages/Productos";
import ProductoDetail from "./pages/ProductoDetail";
import ComponentesPage from "./pages/ComponentesPage";
import ComponenteDetail from "./pages/ComponenteDetail";
import PresupuestosPage from "./pages/PresupuestosPage";
import "./App.css";

const RequireAuth = ({ children }) => {
    const { isAuthenticated } = useAuth();
    if (!isAuthenticated) return <Navigate to="/" replace />;
    return children;
};

function App() {
    return (
        <AuthProvider>
            <Router>
                <div className="app">
                    <NavBar />
                    <ErrorBoundary>
                    <main className="main-content">
                        <Routes>
                            <Route path="/" element={<Login />} />
                            <Route
                                path="/dashboard"
                                element={
                                    <RequireAuth>
                                        <Dashboard />
                                    </RequireAuth>
                                }
                            />
                            <Route
                                path="/productos"
                                element={
                                    <RequireAuth>
                                        <Productos />
                                    </RequireAuth>
                                }
                            />
                            <Route
                                path="/productos/:id"
                                element={
                                    <RequireAuth>
                                        <ProductoDetail />
                                    </RequireAuth>
                                }
                            />
                            <Route
                                path="/presupuestos"
                                element={
                                    <RequireAuth>
                                        <PresupuestosPage />
                                    </RequireAuth>
                                }
                            />
                            <Route
                                path="/componentes"
                                element={
                                    <RequireAuth>
                                        <ComponentesPage />
                                    </RequireAuth>
                                }
                            />
                            <Route
                                path="/componentes/:tipo/:id"
                                element={
                                    <RequireAuth>
                                        <ComponenteDetail />
                                    </RequireAuth>
                                }
                            />
                        </Routes>
                    </main>
                    </ErrorBoundary>
                    <Footer />
                </div>
            </Router>
        </AuthProvider>
    );
}

export default App;